// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".f7e8fe5a0861d516b9f43c93c2b58c4064b02c6c.chunk.js";
};